import { render } from "./RStamoulis.vue?vue&type=template&id=6acf5b70"
import script from "./RStamoulis.vue?vue&type=script&lang=js"
export * from "./RStamoulis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__